<mat-form-field class="w-100">
  <mat-label>{{ placeholder }}</mat-label>
  <mat-select [formControl]="days" [multiple]="isMultiple" 
  (selectionChange)="changeDaySelection()"
  >
    <mat-option 
      *ngFor="let day of listOfDays" 
      [value]="day.value"
      >
      {{ day.text | uppercase }}
    </mat-option>
  </mat-select>
</mat-form-field>